import { render, staticRenderFns } from "./registration-form.vue?vue&type=template&id=a6d3712e&"
import script from "./registration-form.vue?vue&type=script&lang=js&"
export * from "./registration-form.vue?vue&type=script&lang=js&"
import style0 from "./registration-form.vue?vue&type=style&index=0&id=a6d3712e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports